import EventPost from 'flarum/forum/components/EventPost';

/**
 * Marcador de evento na thread: o anúncio (produto vinculado) foi renovado/subido.
 * Renderizado quando o post tem type 'marketplaceProductBumped'.
 */
export default class ProductBumpedPost extends EventPost {
  icon() {
    return 'fas fa-arrow-up';
  }
  descriptionKey() {
    return 'ramon-marketplace.forum.post.bumped';
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/ProductBumpedPost', ProductBumpedPost);